import { ImportGarantie } from "./../../../models/ImportGarantie";
import { Rule } from "../../../models/Rule";
import { FondsPropresService } from "../../../services/fonds-propres.service";
import { ImportPortefeuilleDetail } from "../../../models/ImportPortefeuilleDetail";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "app-view-item-detail",
  templateUrl: "./view-item-detail.component.html",
  styleUrls: ["./view-item-detail.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ViewItemDetailComponent implements OnInit {
  constructor(
    private shared: FondsPropresService,
    private activeModal: NgbActiveModal
  ) {}

  //From Modal:  parameters
  portefeuilleDetail: ImportPortefeuilleDetail;
  importPortefeuilleId: number;

  //From DB
  rules: Rule[] = [];
  importGaranties: ImportGarantie[] = [];

  ngOnInit() {
    this.getSegmentRulesImport(this.portefeuilleDetail.id);
    //this.getImportGaranties(this.importPortefeuilleId, this.portefeuilleDetail.codeDossier);
    this.importGaranties = this.portefeuilleDetail.importGaranties;
  }

  getSegmentRulesImport(importPortefeuilleDetailId: number) {
    this.shared.getSegmentRulesImport(importPortefeuilleDetailId).subscribe(
      (data) => {
        this.rules = data;
      },
      (error) => {
        console.log(error);
      },
      () => {
        if (this.rules == null) {
          this.rules = [];
        }
      }
    );
  }

  /* 
getImportGaranties(importPortefeuilleId: number, codeDossier: string) {

  this.shared.getImportGaranties(importPortefeuilleId, codeDossier).subscribe(
  data => { 
    console.log(data);
    this.importGaranties = data;
  },
  error => { console.log(error);
  },
  () => {
    if(this.importGaranties == null) {
      this.importGaranties = [];
    }

  });
}
*/
}
